export default __webpack_public_path__ + "static/media/bb-00010.4c7e8087.png";